// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.rktechworks",
    name: "ID Pocket",
    homepage: "https://rktechworks.com/idpocket",
    image_id: "c227ee0a-5127-4707-ded9-c3cd81348d00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/id-pocket/id1549462128",
        android: "https://play.google.com/store/apps/details?id=com.rktechworks.idpocket",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "wc://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map